/**
 * Browser entry point. Mounts <App> into #root and loads global styles.
 * StrictMode is on, so effects run twice in development — keep effects idempotent.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './styles/global.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
